const URL = {
  SIM_ACTIVATION_HELP:
    "https://help.netilion.endress.com/hc/en-us/articles/17105208765724-How-the-SIM-Card-activation-of-a-FWR30-workings",
};

export default URL;
